import { redirect } from "react-router";
import { supabase } from "@shared/integrations/supabase/client";

export const indexLoader = async () => {
	const {
		data: { session },
	} = await supabase.auth.getSession();

	if (session?.user) {
		throw redirect("/workspace");
	}

	return null;
};
